export default {
  welcomeBack: "¡Bienvenido de nuevo",
      loadingPlan: "Cargando tu plan...",
      earnRewards: "¡Gana recompensas probando comidas deliciosas hoy!",
      subscribePlan: "Suscríbete a un plan y comienza a ganar recompensas",
      rewards: "Recompensas",
      ourPartners: "Nuestros Socios",
      trustedBy: "Con la confianza de los líderes",
      availableMeals: "Comidas disponibles",
      rewardsLeft: "recompensas restantes",
      referralProgram: "Programa de Referidos",
      inviteFriends: "Invitar a amigos",
      totalReferrals: "Referidos totales",
      referralEarnings: "Ganancias por referidos",
      earnUpTo: "Gana hasta $8,000 por nivel de referencia",
      viewReferralProgram: "Ver programa de referidos",
      rewardTiers: "Niveles de recompensa",
      guide: "Guía",
      agents: "agentes",
      dulceCommercio: {
    "title": "Dulce Commercio",
    "description": "Es un proveedor externo que procesa pagos UPI para los principales sistemas de comercio electrónico.",
    "target": "Diseñado para todos los vendedores, agentes y trabajadores remotos."
  },
};